module.exports = "<button mat-raised-button color=\"accent\" (click)=\"openDialog()\">\n  Add Form\n</button>\n"